<div class="p-4">
    <div class="demo-container">
        <div class="title">ACH</div>
        <h6>ACH BF Setting</h6>
        <select class="col-2" [(ngModel)]="achBfSettingsValue" (change)="patchAchEnvironmentSettings()" data-testid="ach-bf-settings-value">
            <option value="ISO">ISO </option>
            <option value="NACHA">NACHA</option>
        </select>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/system-settings/ach/ach.component.html